export default __webpack_public_path__ + "static/media/pink-color-books.1ae8b67f.png";